<template>
  <div class="page-container">
    <Filter :params="params" @search="searchData" add @add="addNew"></Filter>
    <Table :tableData="tableDataList" :total="total" @update="updatePage" tooltip-effect="light">
      <el-table-column prop="publishTime" :label="$t('service.software.releaseDate')" width="120px" />
      <el-table-column prop="cabinet" :label="$t('service.version.controller')" width="120px" />
      <el-table-column prop="app" label="APP" width="120px" />
      <el-table-column prop="servo" :label="$t('service.version.servo')" width="120px" />
      <el-table-column prop="pushAll" :label="$t('service.version.oneClickUpgrade')" width="120px" />
      <el-table-column label="SCB/PSCB">
        <el-table-column prop="cabV21" label="CAB V2.1" width="120px" />
        <el-table-column prop="miniCab" label="MiniCAB" width="120px" />
      </el-table-column>
      <el-table-column prop="cabV3" label="GSCB(CAB V3)" width="130px" />
      <el-table-column prop="can" :label="$t('service.version.selfDevelopedCanCard')" width="120px" />
      <el-table-column prop="webPackage" :label="$t('service.version.webServicePackage')" width="120px" />
      <el-table-column prop="addOn" label="addon" width="120px" />
      <el-table-column prop="newFunction" :label="$t('service.version.newFeature')" min-width="200">
        <template #default="{row}">
          <el-popover
            placement="top-start"
            :width="320"
            trigger="hover"
          >
            <template #default>
              {{row.newFunction}}
            </template>
            <template #reference>
              <span style="white-space: nowrap;">{{row.newFunction}}</span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="fixedBugs" :label="$t('service.version.bugFix')" min-width="200">
        <template #default="{row}">
          <el-popover
            placement="top-start"
            :width="320"
            trigger="hover"
          >
            <template #default>
              {{row.fixedBugs}}
            </template>
            <template #reference>
              <span style="white-space: nowrap;">{{row.fixedBugs}}</span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="createBy" :label="$t('activity.list.creator')" min-width="200"/>
      <el-table-column prop="createTime" :label="$t('activity.list.createTime')" min-width="200"/>
      <el-table-column prop="updateBy" :label="$t('status.largescreenm.updater')" min-width="200"/>
      <el-table-column prop="updateTime" :label="$t('collect.healthscorelist.updateTime')" min-width="200"/>
      <el-table-column :label="$t('activity.list.operation')" fixed="right" width="180px">
        <template #default="scope">
          <el-button type="text" size="mini" @click="checkDetail(scope.row)">{{$t('service.version.viewMatchingSoftware')}}</el-button>
          <el-button type="text" size="mini" @click="editDetail(scope.row)">{{$t('activity.list.edit')}}</el-button>
          <el-button type="text" style="color: #f56c6c;" size="mini" @click="deleteDetail(scope.row)">{{$t('activity.packetjoin.delete')}}</el-button>
        </template>
      </el-table-column>
    </Table>
    <el-dialog :title="$t('service.version.addVersion')" top="5vh" v-model="dialogFormVisible" destroy-on-close :modal="true" :append-to-body="true">
      <el-form ref="detailformRef" class="dialog-form" :model="detailform" :rules="detailformRules" label-width="200px">
        <el-form-item :label="$t('service.software.releaseDate')" prop="publishTime">
          <el-date-picker
            v-model="detailform.publishTime"
            type="date"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            :placeholder="$t('service.software.releaseDate')"
            clearable
          />
        </el-form-item>
        <el-form-item :label="$t('service.version.controller')" prop="cabinet">
          <el-select
            v-model="detailform.cabinet"
            clearable
            filterable
            :placeholder="$t('service.version.controller')"
            remote
            @change="onPageChange"
          >
            <el-option
              v-for="item in packageList.filter(it=> it.productId == 2)"
              :key="item"
              :label="item.version"
              :value="item.version"
            ></el-option>
          </el-select>
          <!-- <el-input v-model="detailform.cabinet" placeholder="控制器" clearable /> -->
        </el-form-item>
        <el-form-item label="APP" prop="app">
          <el-select
            v-model="detailform.app"
            clearable
            filterable
            placeholder="APP"
            remote
            @change="onPageChange"
          >
            <el-option
              v-for="item in packageList.filter(it=> it.productId == 1)"
              :key="item"
              :label="item.version"
              :value="item.version"
            ></el-option>
          </el-select>
          <!-- <el-input v-model="detailform.app" placeholder="APP" clearable /> -->
        </el-form-item>
        <el-form-item :label="`${$t('service.version.servo')}${detailform.servoSerials.length > 0 ? '(' + detailform.servoSerials.toString()+ ')'  : ''}`" prop="servo">
          <el-select
            v-model="detailform.servo"
            clearable
            filterable
            :placeholder="`${$t('service.version.servo')}${detailform.servoSerials.length > 0 ? '(' + detailform.servoSerials.toString()+ ')'  : ''}`"
            remote
            @change="onPageChange"
          >
            <el-option
              v-for="item in packageList.filter(it=> it.productId == 3)"
              :key="item"
              :label="item.version"
              :value="item.version"
            ></el-option>
          </el-select>
          <!-- <el-input v-model="detailform.servo" placeholder="伺服(Zu, C, Pro, A, S, AL, MAX)" clearable /> -->
        </el-form-item>
        <el-form-item label="" prop="servoSerials">
          <el-checkbox-group v-model="detailform.servoSerials">
            <el-checkbox label="Zu"></el-checkbox>
            <el-checkbox label="C"></el-checkbox>
            <el-checkbox label="Pro"></el-checkbox>
            <el-checkbox label="A"></el-checkbox>
            <el-checkbox label="S"></el-checkbox>
            <el-checkbox label="AL"></el-checkbox>
            <el-checkbox label="MAX"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item :label="$t('service.version.servoMC')" prop="servoMc">
          <el-select
            v-model="detailform.servoMc"
            clearable
            filterable
            :placeholder="$t('service.version.servoMC')"
            remote
            @change="onPageChange"
          >
            <el-option
              v-for="item in packageList.filter(it=> it.productId == 3)"
              :key="item"
              :label="item.version"
              :value="item.version"
            ></el-option>
          </el-select>
          <!-- <el-input v-model="detailform.servoMc" placeholder="伺服(MC)" clearable /> -->
        </el-form-item>
        <el-form-item :label="$t('service.version.oneClickUpgrade')" prop="pushAll">
          <el-select
            v-model="detailform.pushAll"
            clearable
            filterable
            :placeholder="$t('service.version.oneClickUpgrade')"
            remote
            @change="onPageChange"
          >
            <el-option
              v-for="item in packageList.filter(it=> it.productId == 10)"
              :key="item"
              :label="item.version"
              :value="item.version"
            ></el-option>
          </el-select>
          <!-- <el-input v-model="detailform.pushAll" placeholder="一键升级" clearable /> -->
        </el-form-item>
        <el-form-item label="SCB/PSCB(CAB V2.1)">
           <el-select
            v-model="detailform.cabV21"
            clearable
            filterable
            placeholder="SCB/PSCB(CAB V2.1)"
            remote
            @change="onPageChange"
          >
            <el-option
              v-for="item in packageList.filter(it=> it.productId == 4)"
              :key="item"
              :label="item.version"
              :value="item.version"
            ></el-option>
          </el-select>
          <!-- <el-input v-model="detailform.cabV21" placeholder="SCB/PSCB(CAB V2.1)" clearable /> -->
        </el-form-item>
        <el-form-item label="SCB/PSCB(MiniCAB)">
           <el-select
            v-model="detailform.miniCab"
            clearable
            filterable
            placeholder="SCB/PSCB(MiniCAB)"
            remote
            @change="onPageChange"
          >
            <el-option
              v-for="item in packageList.filter(it=> it.productId == 4)"
              :key="item"
              :label="item.version"
              :value="item.version"
            ></el-option>
          </el-select>
          <!-- <el-input v-model="detailform.miniCab" placeholder="SCB/PSCB(MiniCAB)" clearable /> -->
        </el-form-item>
        <el-form-item label="GSCB(CAB V3)">
           <el-select
            v-model="detailform.cabV3"
            clearable
            filterable
            placeholder="GSCB(CAB V3)"
            remote
            @change="onPageChange"
          >
            <el-option
              v-for="item in packageList.filter(it=> it.productId == 15)"
              :key="item"
              :label="item.version"
              :value="item.version"
            ></el-option>
          </el-select>
          <!-- <el-input v-model="detailform.cabV3" placeholder="GSCB(CAB V3)" clearable /> -->
        </el-form-item>
        <el-form-item :label="$t('service.version.selfDevelopedCanCard')">
          <el-select
            v-model="detailform.can"
            clearable
            filterable
            :placeholder="$t('service.version.selfDevelopedCanCard')"
            remote
            @change="onPageChange"
          >
            <el-option
              v-for="item in packageList.filter(it=> it.productId == 9)"
              :key="item"
              :label="item.version"
              :value="item.version"
            ></el-option>
          </el-select>
          <!-- <el-input v-model="detailform.can" placeholder="自研CAN卡" clearable /> -->
        </el-form-item>
        <el-form-item :label="$t('service.version.webServicePackage')" prop="webPackage">
          <el-select
            v-model="detailform.webPackage"
            clearable
            filterable
            :placeholder="$t('service.version.webServicePackage')"
            remote
            @change="onPageChange"
          >
            <el-option
              v-for="item in packageList.filter(it=> it.productId == 14)"
              :key="item"
              :label="item.version"
              :value="item.version"
            ></el-option>
          </el-select>
          <!-- <el-input v-model="detailform.webPackage" placeholder="web服务包" clearable /> -->
        </el-form-item>
        <el-form-item label="addon" prop="addOn">
           <el-select
            v-model="detailform.addOn"
            clearable
            filterable
            placeholder="addon"
            remote
            @change="onPageChange"
          >
            <el-option
              v-for="item in packageList.filter(it=> it.productId == 12)"
              :key="item"
              :label="item.version"
              :value="item.version"
            ></el-option>
          </el-select>
          <!-- <el-input v-model="detailform.addOn" placeholder="addon" clearable /> -->
        </el-form-item>
        <el-form-item :label="$t('service.version.newFeature')">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4}"
            :placeholder="$t('service.version.newFeature')"
            clearable
            v-model="detailform.newFunction"
          />
        </el-form-item>
        <el-form-item :label="$t('service.version.bugFix')">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4}"
            :placeholder="$t('service.version.bugFix')"
            clearable
            v-model="detailform.fixedBugs"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="small" type="primary" @click="editSubmit">{{$t('activity.list.confirm')}}</el-button>
      </template>
    </el-dialog>
    <el-dialog :title="$t('service.version.matchingSoftware')" top="5vh" v-model="dialogTableVisible" destroy-on-close :modal="true" :append-to-body="true" custom-class="dialog-wrapper">
      <el-form class="dialog-form" label-width="180px" :inline="false" label-position="left" v-if="versionInfo">
        <el-form-item class="form-item" :label="$t('service.version.controllerColon')" v-if="versionInfo.cabinet && versionInfo.cabinet.length !==0">
          <el-table class="dialog-table" :data="versionInfo.cabinet" border stripe>
            <el-table-column prop="date" :label="$t('activity.list.date')" ></el-table-column>
            <el-table-column prop="platformName" :label="$t('service.software.platform')" ></el-table-column>
            <el-table-column :label="$t('service.software.installationPackage')" >
              <template #default="{row}">
                <a :href="row.url" download="software">{{row.packageName}}</a>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item class="form-item" label="App：" v-if="versionInfo.app && versionInfo.app.length !==0">
          <el-table class="dialog-table" :data="versionInfo.app" border stripe>
            <el-table-column prop="date" :label="$t('activity.list.date')" ></el-table-column>
            <el-table-column prop="platformName" :label="$t('service.software.platform')" ></el-table-column>
            <el-table-column prop="packageName" :label="$t('service.software.installationPackage')" >
              <template #default="{row}">
                <a :href="row.url" download="software">{{row.packageName}}</a>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item class="form-item" :label="`${$t('service.version.servo')}${detailform.servoSerials.length > 0 ? '(' + detailform.servoSerials.toString()+ ')：'  : ''}`" v-if="versionInfo.servo && versionInfo.servo.length !==0">
          <el-table class="dialog-table" :data="versionInfo.servo" border stripe>
            <el-table-column prop="date" :label="$t('activity.list.date')" ></el-table-column>
            <el-table-column prop="platformName" :label="$t('service.software.platform')" ></el-table-column>
            <el-table-column prop="packageName" :label="$t('service.software.installationPackage')" >
              <template #default="{row}">
                <a :href="row.url" download="software">{{row.packageName}}</a>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item class="form-item" :label="$t('service.version.servoMC')" v-if="versionInfo.servoMc && versionInfo.servoMc.length !==0">
          <el-table class="dialog-table" :data="versionInfo.servoMc" border stripe>
            <el-table-column prop="date" :label="$t('activity.list.date')" ></el-table-column>
            <el-table-column prop="platformName" :label="$t('service.software.platform')" ></el-table-column>
            <el-table-column prop="packageName" :label="$t('service.software.installationPackage')" >
              <template #default="{row}">
                <a :href="row.url" download="software">{{row.packageName}}</a>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item class="form-item" label="SCB/PSCB(CAB V2.1)：" v-if="versionInfo.cab_v21 && versionInfo.cab_v21.length !==0">
          <el-table class="dialog-table" :data="versionInfo.cab_v21" border stripe>
            <el-table-column prop="date" :label="$t('activity.list.date')" ></el-table-column>
            <el-table-column prop="platformName" :label="$t('service.software.platform')" ></el-table-column>
            <el-table-column prop="packageName" :label="$t('service.software.installationPackage')" >
              <template #default="{row}">
                <a :href="row.url" download="software">{{row.packageName}}</a>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item class="form-item" label="SCB/PSCB(MiniCAB)：" v-if="versionInfo.miniCab && versionInfo.miniCab.length !==0">
          <el-table class="dialog-table" :data="versionInfo.miniCab" border stripe>
            <el-table-column prop="date" :label="$t('activity.list.date')" ></el-table-column>
            <el-table-column prop="platformName" :label="$t('service.software.platform')" ></el-table-column>
            <el-table-column prop="packageName" :label="$t('service.software.installationPackage')" >
              <template #default="{row}">
                <a :href="row.url" download="software">{{row.packageName}}</a>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item class="form-item" label="GSCB(CAB V3)：" v-if="versionInfo.cab_v3 && versionInfo.cab_v3.length !==0">
          <el-table class="dialog-table" :data="versionInfo.cab_v3" border stripe>
            <el-table-column prop="date" :label="$t('activity.list.date')" ></el-table-column>
            <el-table-column prop="platformName" :label="$t('service.software.platform')"></el-table-column>
            <el-table-column prop="packageName" :label="$t('service.software.installationPackage')" >
              <template #default="{row}">
                <a :href="row.url" download="software">{{row.packageName}}</a>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item class="form-item" :label="$t('service.version.webServicePackage')" v-if="versionInfo.webPackage && versionInfo.webPackage.length !==0">
          <el-table class="dialog-table" :data="versionInfo.webPackage" border stripe>
            <el-table-column prop="date" :label="$t('activity.list.date')" ></el-table-column>
            <el-table-column prop="platformName" :label="$t('service.software.platform')" ></el-table-column>
            <el-table-column prop="packageName" :label="$t('service.software.installationPackage')" >
              <template #default="{row}">
                <a :href="row.url" download="software">{{row.packageName}}</a>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item class="form-item" label="addon：" v-if="versionInfo.addOn && versionInfo.addOn.length !==0">
          <el-table class="dialog-table" :data="versionInfo.addOn" border stripe>
            <el-table-column prop="date" :label="$t('activity.list.date')" ></el-table-column>
            <el-table-column prop="platformName" :label="$t('service.software.platform')" ></el-table-column>
            <el-table-column prop="packageName" :label="$t('service.software.installationPackage')" >
              <template #default="{row}">
                <a :href="row.url" download="software">{{row.packageName}}</a>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item class="form-item" :label="$t('service.version.oneClickUpgrade')" v-if="versionInfo.pushAll && versionInfo.pushAll.length !==0">
          <el-table class="dialog-table" :data="versionInfo.pushAll" border stripe>
            <el-table-column prop="date" :label="$t('activity.list.date')" ></el-table-column>
            <el-table-column prop="platformName" :label="$t('service.software.platform')" ></el-table-column>
            <el-table-column prop="packageName" :label="$t('service.software.installationPackage')" >
              <template #default="{row}">
                <a :href="row.url" download="software">{{row.packageName}}</a>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { request } from "@/utils/request";
import { common } from "@/common/mixin";
import { reactive, toRefs } from "@vue/reactivity";
import { ElMessage, ElMessageBox } from "element-plus";
import Table from "@/components/table/index";
import Filter from "@/components/table/filter";
import { useI18n } from 'vue-i18n'
export default {
  components: {
    Table,
    Filter,
  },
  mixins: [common],
  setup() {
    const { t } = useI18n()
    const state = reactive({
      query: {},
      page: 1,
      size: 10,
      total: 0,
      dialogFormVisible: false,
      tableDataList: [],
      detailformRef: null,
      detailform: {
        id: '',
        publishTime: '',
        cabinet: '',
        app: '',
        servo: '',
        servoMc: '',
        pushAll: '',
        cabV21: '',
        miniCab: '',
        can: '',
        newFunction: '',
        fixedBugs: '',
        webPackage: '',
        addOn: '',
        cabV3: '',
        servoSerials: []
      },
      params: [
        {
          key: "cabinet",
          value: "",
          label: t('service.version.controller'),
        },
        {
          key: "app",
          value: "",
          label: "APP",
        },
        {
          key: "servo",
          value: "",
          label: t('service.version.servo'),
        }
      ],
      dialogTableVisible: false,
      versionInfo: null,
      packageList: [],
      authList: JSON.parse(window.localStorage.getItem('authList'))
    })
    const detailformRules = reactive({
      publishTime: {
        required: true,
        message: t('service.software.selectReleaseDate'),
        trigger: 'change',
      },
      // cabinet: {
      //   required: true,
      //   message: '请输入控制器',
      //   trigger: 'blur',
      // },
      app: {
        required: true,
        message: t('service.version.enterApp'),
        trigger: 'blur'
      },
      servo: {
        required: true,
        message: t('service.version.enterServo'),
        trigger: 'blur',
      }
    })
    const getData = async () => {
      console.log("query", state.query);
      try {
        const res = await request("getVersionMappingList", {
          ...state.query,
          pageNum: state.page,
          pageSize: state.size,
        });
        state.tableDataList = res.records;
        state.total = res.total;
      } catch (error) {
        console.error(error);
      }
    };
    const searchData = async (data) => {
      state.query = data;
      getData()
    };
    const updatePage = (page, size) => {
      state.page = page || 1;
      state.size = size || 10;
      getData();
    };
    const addNew = () => {
      for (let key of Object.keys(state.detailform)) {
        state.detailform[key] = "";
        state.detailform.servoSerials = []
      }
      state.dialogFormVisible = true;
      console.log(state.detailform);
      getPackageData()
    }
    // 查看配套软件
    const checkDetail = async (row) => {
      try {
        state.dialogTableVisible=true
        state.versionInfo= row.packages || {}
        state.detailform.servoSerials = row.servoSerials == null ? [] : row.servoSerials
      } catch (error) {
        console.error(error);
      }
    };
    const editDetail = (row) => {
      for (let key of Object.keys(state.detailform)) {
        state.detailform[key] = row[key]??null;
        state.detailform.servoSerials = row.servoSerials == null ? [] : row.servoSerials
      }
      state.dialogFormVisible = true;
      console.log(state.detailform);
      getPackageData()
    }
    const deleteDetail = async (row) => {
      try {
        await ElMessageBox.confirm(
          t('activity.list.confirmDelete'),
          {
            confirmButtonText: t('activity.list.confirm1'),
            cancelButtonText: t('activity.list.cancel'),
            type: 'warning',
          }
        )
        await request("deleteVersionMapping", {
          id: row.id
        })
        getData()
        ElMessage({
          showClose: true,
          type: "success",
          message: t('activity.packetreceive.deleteSuccess')
        })
      } catch (error) {
        console.error(error)
      }
    } 
    const editSubmit = async () => {
      console.log('onSubmit', state.detailform)
      try {
        state.detailformRef && await state.detailformRef.validate()
        const url = state.detailform.id ? 'updateVersionMappering' : 'saveVersionMapping'
        await request(url, state.detailform)
        state.dialogFormVisible = false
        getData()
        ElMessage({
          showClose: true,
          type: "success",
          message: t('activity.list.submitSuccess')
        })
      } catch (error) {
        console.error(error)
      }
    }
    const getPackageData = async () => {
      try {
        const res = await request("getPackageList", {
          version: '',
          productList: [],
          pageNum: state.page,
          pageSize: 500,
        });
        state.packageList = res.records
      } catch (error) {
        console.error(error);
      }
    };

    getData();
    return {
      ...toRefs(state),
      detailformRules,
      getData,
      searchData,
      updatePage,
      addNew,
      checkDetail,
      editDetail,
      deleteDetail,
      editSubmit
    };
  },
};
</script>
<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
</style>